import React from 'react'
import { Link } from 'gatsby'

import styles from './documents.module.scss'

export default ({ post }) => (
  <div className={styles.documentWrapper}>
    <span className={styles.title}>
      <Link to={post.frontmatter.path}>{post.frontmatter.title}</Link>
    </span>
    <span className={styles.date}>{post.frontmatter.date}</span>
  </div>
)
